import { Ban } from 'lucide-react';

import { useAcknowledgeFlag } from '../../features/flags/mutations';
import { useActiveFlags } from '../../features/flags/queries';
import { Button } from '../ui/Button';

function label(kind: string): string {
  return kind
    .split('_')
    .map((part) => part.charAt(0) + part.slice(1).toLowerCase())
    .join(' ');
}

export function BehaviouralFlagBanner() {
  const flags = useActiveFlags();
  const acknowledge = useAcknowledgeFlag();
  const blockFlag = (flags.data ?? []).find((flag) => flag.severity === 'BLOCK');

  if (!blockFlag) return null;

  return (
    <div className="sticky top-0 z-20 border-b border-danger/30 bg-danger/10 px-4 py-3 text-danger">
      <div className="mx-auto flex max-w-5xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex min-w-0 gap-2">
          <Ban className="mt-0.5 h-5 w-5 shrink-0" aria-hidden />
          <div className="min-w-0">
            <p className="font-semibold">
              {label(blockFlag.kind)}
              {blockFlag.subjectSymbol ? `: ${blockFlag.subjectSymbol}` : ''}
            </p>
            <p className="text-sm text-danger/80">A BLOCK-severity behavioural flag is active.</p>
          </div>
        </div>
        <Button
          aria-label={`Acknowledge ${blockFlag.kind}`}
          disabled={acknowledge.isPending}
          onClick={() => acknowledge.mutate(blockFlag.id)}
          size="sm"
          variant="secondary"
        >
          Ack
        </Button>
      </div>
    </div>
  );
}
